import React, { useEffect, useState } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux';
import { Typography } from '@mui/material'
import * as actions from '../../reducers/formTable';
import { fetchDispath } from '../../functions/fetch'
// import { enqueueSnackbar } from '../../reducers/notifier'
import { getShare } from '../../api/share'
import GroupTableShare from './GroupTableShare'

const formGname = 'groupEstimateShare'
const formRname = 'groupResEstimateShare'
export default function EstimateListShare({ match }) {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(actions.initFormTable({ name: formGname }))
    dispatch(actions.initFormTable({ name: formRname }))
    return () => {
      dispatch(actions.clearFormTable(formGname))
      dispatch(actions.clearFormTable(formRname))
    }
  }, [dispatch])
  useEffect(() => {
    dispatch(fetchDispath({
      querty: {
        link: match.params.id
      },
      progress: true,
      request: getShare,
    })).then(res => {
      const { list, group } = res.get
      let gobj = {}
      group.forEach((el, i) => {
        gobj[el.id] = { res: [], summ: 0 };
      });
      list.forEach((el, i) => {
        const summ = Number(el.summ)
        gobj[el.idGroup].res.push('id' + el.id + '_' + i);
        gobj[el.idGroup].summ += summ
      });
      batch(() => {
        dispatch(actions.loadFormTable({ count: list.length, get: list }, { name: formRname, id: 'id' }))
        dispatch(actions.loadFormTable({
          count: group.length, get: group.map(e => {
            return { ...e, res: gobj[e.id].res, ressumm: gobj[e.id].summ }
          })
        }, { name: formGname, id: 'id' }))
      })
    }).catch(err => console.log(err))
  }, [dispatch, match.params.id])
  return <div className='App-paper'>
    <Typography variant='h6'> Смета</Typography>
    <SummPrice formName={formRname} />
    <GroupTableShare formGname={formGname} formRname={formRname} />
  </div>
}

function SummPrice({ formName }) {
  const allIdsEst = useSelector(state => state.formTable[formName]?.allIds || [])
  const byIdEst = useSelector(state => state.formTable[formName]?.byId || {})
  let summMaterial = 0
  let summWork = 0
  function calc() {
    allIdsEst.forEach(key=>{
      const obj = byIdEst[key]
      if (obj.type === 'material') {
        summMaterial += Number(obj.summ) || 0
      }
      else {
        summWork += Number(obj.summ) || 0
      }
    })
  }
  calc()
  return <>
    <Typography variant='h5'>{'Всего по смете: ' + (Math.round(100 * (summMaterial + summWork)) / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}</Typography>
    <Typography variant='body1'>{'Всего материалов: ' + (Math.round(100 * (summMaterial)) / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}</Typography>
    <Typography variant='body1'>{'Всего работ: ' + (Math.round(100 * (summWork)) / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}</Typography>
  </>
}